import { usePlatformCatalogQuery, useWorkspaceDirectoryQuery } from '@platform/state/api';
import { globalTemplateCount } from './globalTemplateCount';
import type { IGlobalKpis } from './IGlobalKpis';

/**
 * Плитки огляду «Налаштування · Глобально» (прототип v4: «Шаблони модулів» — Object.keys(TEMPLATES) і вимкнені шаблони, «Глобальні
 * форми» — кількість глобальних форм, «Робочі простори» — усі простори платформи і «N з власним розміщенням полів» — workspaces.filter(w =>
 * w.layoutOverride)): глобальний каталог (ADR-027; кількість просторів із власним розміщенням рахує сервер) і каталог просторів
 * (GET /workspaces/directory). `skip` — рівень не глобальний чи немає глобальних прав.
 */
export function useGlobalKpis(skip: boolean): IGlobalKpis {
  const { data: platform } = usePlatformCatalogQuery(undefined, { skip });
  const { data: directory } = useWorkspaceDirectoryQuery(undefined, { skip });
  const off = new Set(platform?.modules.filter((m) => !m.enabled).map((m) => m.key));
  const templates = platform?.recordTypes.filter((r) => r.order !== null) ?? [];
  return {
    templates: globalTemplateCount(platform),
    disabled: (templates.length ? templates : platform?.recordTypes ?? []).filter((r) => off.has(r.module)).length,
    forms: platform?.recordTypes.filter((r) => r.globalForm).length,
    workspaces: directory?.available ? directory.items.length : undefined,
    ownLayout: platform?.workspacesWithOwnLayout,
  };
}
